"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  FlipVerticalDown: ['flip-vertical-down', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0.750 14.749 A1.250 1.250 0 1 0 3.250 14.749 A1.250 1.250 0 1 0 0.750 14.749 Z', 'M0.750 18.749 A1.250 1.250 0 1 0 3.250 18.749 A1.250 1.250 0 1 0 0.750 18.749 Z', 'M0.750 22.749 A1.250 1.250 0 1 0 3.250 22.749 A1.250 1.250 0 1 0 0.750 22.749 Z', 'M5.750 22.749 A1.250 1.250 0 1 0 8.250 22.749 A1.250 1.250 0 1 0 5.750 22.749 Z', 'M10.750 22.749 A1.250 1.250 0 1 0 13.250 22.749 A1.250 1.250 0 1 0 10.750 22.749 Z', 'M15.750 22.749 A1.250 1.250 0 1 0 18.250 22.749 A1.250 1.250 0 1 0 15.750 22.749 Z', 'M20.750 14.749 A1.250 1.250 0 1 0 23.250 14.749 A1.250 1.250 0 1 0 20.750 14.749 Z', 'M20.750 18.749 A1.250 1.250 0 1 0 23.250 18.749 A1.250 1.250 0 1 0 20.750 18.749 Z', 'M20.750 22.749 A1.250 1.250 0 1 0 23.250 22.749 A1.250 1.250 0 1 0 20.750 22.749 Z', 'M0,11.5a.75.75,0,0,0,.75.75H8.489a.251.251,0,0,0,.25-.265c-.01-.161-.018-.323-.018-.485a12,12,0,0,1,2.951-7.881,2,2,0,0,1,3.016,2.627A8,8,0,0,0,12.721,11.5c0,.173.006.345.018.517a.249.249,0,0,0,.249.233H23.25a.75.75,0,0,0,0-1.5A.25.25,0,0,1,23,10.5V1.749A1.752,1.752,0,0,0,21.25,0H2.75A1.752,1.752,0,0,0,1,1.749V10.5a.25.25,0,0,1-.25.25A.75.75,0,0,0,0,11.5Z', 'M11.471,11.5a9.249,9.249,0,0,1,2.275-6.075.75.75,0,0,0-1.131-.985A10.736,10.736,0,0,0,10.63,15.2a.25.25,0,0,1-.1.3l-.9.549-.767.468a.751.751,0,0,0,.215,1.37l1.782.429,2.2.532a.8.8,0,0,0,.152.017l.014,0h.01a.744.744,0,0,0,.664-.423l0-.008a.751.751,0,0,0,.061-.139l.462-1.873.524-2.121a.75.75,0,0,0-1.118-.821l-.726.443-.828.505a.25.25,0,0,1-.369-.138A9.228,9.228,0,0,1,11.471,11.5Z']],
  FlipVerticalUp: ['flip-vertical-up', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0.750 9.249 A1.250 1.250 0 1 0 3.250 9.249 A1.250 1.250 0 1 0 0.750 9.249 Z', 'M0.750 5.249 A1.250 1.250 0 1 0 3.250 5.249 A1.250 1.250 0 1 0 0.750 5.249 Z', 'M0.750 1.249 A1.250 1.250 0 1 0 3.250 1.249 A1.250 1.250 0 1 0 0.750 1.249 Z', 'M5.750 1.249 A1.250 1.250 0 1 0 8.250 1.249 A1.250 1.250 0 1 0 5.750 1.249 Z', 'M10.750 1.249 A1.250 1.250 0 1 0 13.250 1.249 A1.250 1.250 0 1 0 10.750 1.249 Z', 'M15.750 1.249 A1.250 1.250 0 1 0 18.250 1.249 A1.250 1.250 0 1 0 15.750 1.249 Z', 'M20.750 9.249 A1.250 1.250 0 1 0 23.250 9.249 A1.250 1.250 0 1 0 20.750 9.249 Z', 'M20.750 5.249 A1.250 1.250 0 1 0 23.250 5.249 A1.250 1.250 0 1 0 20.750 5.249 Z', 'M20.750 1.249 A1.250 1.250 0 1 0 23.250 1.249 A1.250 1.250 0 1 0 20.750 1.249 Z', 'M0,12.5a.75.75,0,0,0,.75.75A.25.25,0,0,1,1,13.5v8.75A1.752,1.752,0,0,0,2.75,24h18.5A1.752,1.752,0,0,0,23,22.249V13.5a.25.25,0,0,1,.25-.25.75.75,0,0,0,0-1.5H12.988a.249.249,0,0,0-.249.233c-.012.172-.018.344-.018.517a8,8,0,0,0,1.967,5.255,2,2,0,0,1-3.016,2.627A12,12,0,0,1,8.721,12.5c0-.162.008-.324.018-.485a.254.254,0,0,0-.068-.187.25.25,0,0,0-.182-.078H.75A.75.75,0,0,0,0,12.5Z', 'M9.971,12.5a10.742,10.742,0,0,0,2.644,7.06.75.75,0,1,0,1.131-.984,9.212,9.212,0,0,1-1.837-8.868.25.25,0,0,1,.15-.159.253.253,0,0,1,.218.021l.828.5.726.443A.75.75,0,0,0,14.949,9.7l-.524-2.121L13.963,5.7a.771.771,0,0,0-.055-.116c-.008-.017-.015-.033-.024-.05a.706.706,0,0,0-.14-.185c-.009-.009-.013-.022-.023-.031S13.7,5.31,13.69,5.3a.723.723,0,0,0-.164-.095.756.756,0,0,0-.12-.045.858.858,0,0,0-.124-.016.691.691,0,0,0-.176,0c-.016,0-.031,0-.047,0l-2.2.532-1.782.43a.751.751,0,0,0-.215,1.37l.767.468.9.549a.248.248,0,0,1,.1.3A10.76,10.76,0,0,0,9.971,12.5Z']],
  ReflectUp: ['reflect-up', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.75,12a1,1,0,0,0-1-1h-14a1,1,0,0,0,0,2h14A1,1,0,0,0,23.75,12Z', 'M16.987,16.176a1.793,1.793,0,0,0-2.474,0L8.927,21.762a1.107,1.107,0,0,0,.823,1.987h12a1.107,1.107,0,0,0,.823-1.987Z', 'M21.75.249h-12A1.169,1.169,0,0,0,8.559.92a1.169,1.169,0,0,0,.368,1.316L15.22,8.529a.748.748,0,0,0,1.06,0l6.293-6.293A1.169,1.169,0,0,0,22.941.92,1.169,1.169,0,0,0,21.75.249Z', 'M7.25,19.5a1,1,0,0,0,0-2A4.995,4.995,0,0,1,3.781,8.906.25.25,0,0,1,4.2,9.06l.048.489a.5.5,0,0,0,.352.428A.488.488,0,0,0,4.75,10a.5.5,0,0,0,.384-.18l2.5-3a.5.5,0,0,0-.107-.736l-3-2a.5.5,0,0,0-.775.466l.163,1.627a.248.248,0,0,1-.125.242A7,7,0,0,0,7.25,19.5Z']],
  ReflectDown: ['reflect-down', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.249,11h-14a1,1,0,0,0,0,2h14a1,1,0,0,0,0-2Z', 'M14.249.249h-12A1.169,1.169,0,0,0,1.058.92a1.169,1.169,0,0,0,.368,1.316L7.012,7.822a1.753,1.753,0,0,0,2.474,0l5.586-5.586A1.169,1.169,0,0,0,15.44.92,1.169,1.169,0,0,0,14.249.249Z', 'M9.486,16.176a1.752,1.752,0,0,0-2.474,0L1.426,21.762a1.169,1.169,0,0,0-.368,1.316,1.169,1.169,0,0,0,1.191.671h13a.75.75,0,0,0,.53-1.28Z', 'M23.75,11.5a7.008,7.008,0,0,0-7-7,1,1,0,0,0,0,2,4.993,4.993,0,0,1,3.468,8.592.248.248,0,0,1-.259.055.252.252,0,0,1-.163-.21l-.048-.487a.5.5,0,0,0-.882-.27l-2.5,3a.5.5,0,0,0,.107.736l3,2A.5.5,0,0,0,19.75,20a.509.509,0,0,0,.258-.071.5.5,0,0,0,.24-.479l-.163-1.627a.25.25,0,0,1,.125-.243A6.985,6.985,0,0,0,23.75,11.5Z']]
};
exports["default"] = _default;